import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CoreValues from './components/CoreValues';
import ProductCategories from './components/ProductCategories';
import FeaturedProducts from './components/FeaturedProducts';
import HealthRemedies from './components/HealthRemedies';
import WhyChoose from './components/WhyChoose';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import SEO from '@/components/SEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pearlfoods.pk';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Pearl Foods Islamabad – 100% Organic Handmade Natural Food Products',
    description: 'Pearl Foods Islamabad offers 100% organic, handmade, non-processed food products including essential oils, gluten-free flour, hand ground spices, seeds and recipe masalas.',
    url: siteUrl,
    mainEntity: {
      '@type': 'LocalBusiness',
      name: 'Pearl Foods',
      image: `${siteUrl}/logo.png`,
      description: '100% organic handmade non-processed food products from Islamabad, Pakistan',
      url: siteUrl,
      telephone: '+923445299984',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Islamabad',
        addressCountry: 'PK',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 33.6844,
        longitude: 73.0479,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+923445299984',
        contactType: 'customer service',
        availableLanguage: ['English', 'Urdu'],
      },
      priceRange: '$$',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '09:00',
          closes: '21:00',
        },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Pearl Foods',
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    description: '100% organic handmade non-processed food products from Islamabad, Pakistan',
    sameAs: ['https://wa.me/923445299984'],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Islamabad',
      addressCountry: 'PK',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+923445299984',
      contactType: 'customer service',
      availableLanguage: ['English', 'Urdu'],
    },
  },
];

const Home = () => {
  return (
    <main>
      <SEO
        title="Pearl Foods Islamabad – 100% Organic Handmade Natural Food Products"
        description="Pearl Foods Islamabad offers 100% organic, handmade, non-processed food products including essential oils, gluten-free flour, hand ground spices, seeds and recipe masalas. Pure, chemical-free traditional wellness."
        keywords="organic food Islamabad, handmade natural products, pure organic oils, gluten free flour, hand ground spices, organic seeds, recipe masalas, superfoods, natural remedies"
        canonicalPath="/"
        image="https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/a6f73e54d84468a1001c90ccc635046b.png"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <CoreValues />
      <ProductCategories />
      <FeaturedProducts />
      <HealthRemedies />
      <WhyChoose />
      <GallerySection />
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </main>
  );
};

export default Home;